import { render } from "./mvt-mapstatic.vue?vue&type=template&id=0a498831"
import script from "./mvt-mapstatic.js?vue&type=script&lang=js"
export * from "./mvt-mapstatic.js?vue&type=script&lang=js"

import "./mvt-mapstatic.vue?vue&type=style&index=0&id=0a498831&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__